import { Component } from 'react'
import { Card, Grid, Typography } from '@mui/material';
import { appContext } from '../../../../AppContext';
import IbssSwitchLabel, { LabelPlacementType } from '../../../../Components/Inputs/Switch/IbssSwitchLabel';
import IbssButton from '../../../../Components/Buttons/Button/IbssButton';
import { PageHelper } from './PageHelper';

class DataPrivacyState
{
    public DataPrivacy = PageHelper.getUserPrefrenceJson();
    public isLoading = false;
    public dataPrivacy = false;
};

class DataPrivacy extends Component<any, DataPrivacyState> {
    private labels = appContext().labels;
    private alert = appContext().alert;
    private userPreferences = appContext().userPreferencesService;
    private local = appContext().localStorageProvider;


    constructor(props: any)
    {
        super(props)
        this.state = new DataPrivacyState();
    };

    componentDidMount()
    {
        this.setState({ isLoading: true });
        const response = this.local.getUserPreferences();
        this.setState({ isLoading: false, dataPrivacy: response?.PrivacyPrefs && response?.PrivacyPrefs?.ShareLocation === 0 ? false : true, DataPrivacy: response, });
    };

    public change = (e: any) =>
    {
        this.setState({
            dataPrivacy: e.target.checked
        });
    };

    public submitDataPrivacy = async () =>
    {
        const payload = {
            ...this.state.DataPrivacy,
            PrivacyPrefs:
            {
                ShareLocation: this.state.dataPrivacy === false ? 0 : 1,
            },

        };
        try
        {
            await this.userPreferences.update(payload);
            this.alert.show(this.labels.HubLabelSuccess, this.labels.HubLabelDataHasBeenSavedSuccessfully);
        }
        catch { }
    };

    render()
    {
        return (
            <>
                <Grid container>
                    <Card className='card-userPref'>
                        <Grid
                            container
                            gap={1}
                        >
                            <Typography className='card-userPref-title' variant="h6" gutterBottom>{this.labels.HubTitleDataPrivacy}</Typography>

                            <Typography className='card-userPref-text mb-32' variant="body2" gutterBottom>{this.labels.HubSubTitleDataPrivacy}</Typography>

                        </Grid>

                        <Grid
                            container
                            item
                            display={"flex"}
                            alignItems="start"
                            direction="column"
                            gap={2}
                        >
                            <IbssSwitchLabel
                                labelClasses={{ "style": { margin: "16px 0px" } }}
                                label={this.labels.HubLabelLocationTracking}
                                labelPlacement={LabelPlacementType.start}
                                checked={this.state.dataPrivacy}
                                onChange={this.change}
                                name="ShareLocation"
                            />
                        </Grid>
                    </Card>
                </Grid>
                <div className='btn-right'>
                    <IbssButton variant='contained' onClick={() => { this.submitDataPrivacy() }}>
                        {this.labels.HubButtonSave}
                    </IbssButton>
                </div>
            </>
        )
    }
};

export default DataPrivacy;
